import React, { useEffect } from "react";
import { Link, NavLink } from "react-router-dom";

const Services = () => {
    useEffect(() => {
        if (window.jQuery) {
            const $ = window.jQuery;
            if ($('.testimonials-carousel_2').length) {
                $('.testimonials-carousel_2').owlCarousel({
                    loop: true,
                    margin: 30,
                    nav: false,
                    dots: true,
                    autoplay: true,
                    autoplayTimeout: 6000,
                    smartSpeed: 300,
                    responsive: {
                        0: { items: 1 },
                        600: { items: 1 },
                        768: { items: 1 },
                        992: { items: 2 },
                        1200: { items: 3 }
                    }
                });
            }
            if (window.WOW) {
                new window.WOW().init();
            }
        }
    }, []);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    return (
        <>
            <div className="boxed_wrapper ltr">
                {/*Start breadcrumb area paroller*/}
                <section className="breadcrumb-area">
                    <div className="breadcrumb-area-bg" style={{ backgroundImage: 'url(/assets/images/breadcrumb/breadcrumb-1.jpg)' }}>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="inner-content">
                                    <div className="title">
                                        <h2>Our Services</h2>
                                    </div>
                                    <div className="breadcrumb-menu">
                                        <ul>
                                            <li><Link to="/">Home</Link></li>
                                            <li><i className="fa fa-angle-right" aria-hidden="true" /></li>
                                            <li className="active">Our Services</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/*End breadcrumb area*/}


                {/*Start Service Style1 Area*/}
                <section className="service-style1-area pdbtm100">
                    <div className="shape1 wow slideInLeft" data-wow-delay="100ms" data-wow-duration="3500ms">
                        <img className="rotate-me" src="assets/images/shape/service-style1-shape1.png" alt="" />
                    </div>
                    <div className="container">
                        <div className="sec-title text-center">
                            <div className="sub-title">
                                <p>Quality Services</p>
                            </div>
                            <h2>We’re Prodviding Quality<br /> Roofing Services</h2>
                        </div>
                        <div className="row">
                            {/*Start Single Service Style1*/}
                            <div className="col-xl-4 col-lg-12">
                                <div className="single-service-style1 text-center wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                                    <div className="img-holder">
                                        <div className="inner">
                                            <img src="assets/images/services/service-v1-1.jpg" alt="" />
                                        </div>
                                        <div className="shape-bg" style={{ backgroundImage: 'url(assets/images/shape/service-image-shape.png)' }} />
                                    </div>
                                    <div className="title-holder">
                                        <div className="icon">
                                            <div className="shape1" />
                                            <span className="flaticon-roof" />
                                        </div>
                                        <h3><NavLink to="/ArchitectureDesign">Architecture Design</NavLink></h3>
                                        <div className="inner-text">
                                            <p>Innovative and sustainable architectural solutions tailored to your vision.</p>
                                        </div>
                                        <div className="readmore-button">
                                            <NavLink to="/ArchitectureDesign"><span className="flaticon-right-arrow-1" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*End Single Service Style1*/}
                            {/*Start Single Service Style1*/}
                            <div className="col-xl-4 col-lg-12">
                                <div className="single-service-style1 text-center wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                                    <div className="img-holder">
                                        <div className="inner">
                                            <img src="assets/images/services/service-v1-2.jpg" alt="" />
                                        </div>
                                        <div className="shape-bg" style={{ backgroundImage: 'url(assets/images/shape/service-image-shape.png)' }} />
                                    </div>
                                    <div className="title-holder">
                                        <div className="icon">
                                            <div className="shape1" />
                                            <span className="flaticon-broken-house" />
                                        </div>
                                        <h3><NavLink to="/BuildingConstruction">Building Construction</NavLink></h3>
                                        <div className="inner-text">
                                            <p>End-to-end construction management with quality assurance and timely delivery.</p>
                                        </div>
                                        <div className="readmore-button">
                                            <NavLink to="/BuildingConstruction"><span className="flaticon-right-arrow-1" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*End Single Service Style1*/}
                            {/*Start Single Service Style1*/}
                            <div className="col-xl-4 col-lg-12">
                                <div className="single-service-style1 text-center wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                                    <div className="img-holder">
                                        <div className="inner">
                                            <img src="assets/images/services/service-v1-3.jpg" alt="" />
                                        </div>
                                        <div className="shape-bg" style={{ backgroundImage: 'url(assets/images/shape/service-image-shape.png)' }} />
                                    </div>
                                    <div className="title-holder">
                                        <div className="icon">
                                            <div className="shape1" />
                                            <span className="flaticon-wrench" />
                                        </div>
                                        <h3><NavLink to="/LayoutPlanning">Layout Planning</NavLink></h3>
                                        <div className="inner-text">
                                            <p>Strategic land development and township planning for optimal space utilization.</p>
                                        </div>
                                        <div className="readmore-button">
                                            <NavLink to="/LayoutPlanning"><span className="flaticon-right-arrow-1" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*End Single Service Style1*/}
                            {/*Start Single Service Style1*/}
                            <div className="col-xl-4 col-lg-12">
                                <div className="single-service-style1 text-center wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                                    <div className="img-holder">
                                        <div className="inner">
                                            <img src="assets/images/services/service-v1-4.jpg" alt="" />
                                        </div>
                                        <div className="shape-bg" style={{ backgroundImage: 'url(assets/images/shape/service-image-shape.png)' }} />
                                    </div>
                                    <div className="title-holder">
                                        <div className="icon">
                                            <div className="shape1" />
                                            <span className="flaticon-roof-1" />
                                        </div>
                                        <h3><NavLink to="/TDRConsultancy">TDR Consultancy</NavLink></h3>
                                        <div className="inner-text">
                                            <p>Expert Transfer of Development Rights consultation and documentation services.</p>
                                        </div>
                                        <div className="readmore-button">
                                            <NavLink to="/TDRConsultancy"><span className="flaticon-right-arrow-1" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*End Single Service Style1*/}
                            {/*Start Single Service Style1*/}
                            <div className="col-xl-4 col-lg-12">
                                <div className="single-service-style1 text-center wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                                    <div className="img-holder">
                                        <div className="inner">
                                            <img src="assets/images/services/service-v1-5.jpg" alt="" />
                                        </div>
                                        <div className="shape-bg" style={{ backgroundImage: 'url(assets/images/shape/service-image-shape.png)' }} />
                                    </div>
                                    <div className="title-holder">
                                        <div className="icon">
                                            <div className="shape1" />
                                            <span className="flaticon-roof-3" />
                                        </div>
                                        <h3><NavLink to="/GovernmentSchemes">Government Schemes</NavLink></h3>
                                        <div className="inner-text">
                                            <p>Navigate government housing schemes and subsidies with our expert guidance.</p>
                                        </div>
                                        <div className="readmore-button">
                                            <NavLink to="/GovernmentSchemes"><span className="flaticon-right-arrow-1" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*End Single Service Style1*/}

                        </div>
                    </div>
                </section>
                {/*End Service Style1 Area*/}




                {/*Start Choose  Style1 Area*/}
                <section className="choose-style1-area">
                    <div className="shape1 wow slideInDown" data-wow-delay="500ms" data-wow-duration="5000ms">
                        <img className="float-bob-y" src="assets/images/shape/thm-shape-9.png" alt="" />
                    </div>
                    <div className="shape2 wow slideInRight" data-wow-delay="500ms" data-wow-duration="7000ms">
                        <img className="float-bob-x" src="assets/images/shape/thm-shape-10.png" alt="" />
                    </div>
                    <div className="shape3 wow slideInDown" data-wow-delay="100ms" data-wow-duration="2000ms">
                        <img className="float-bob-y" src="assets/images/shape/thm-shape-11.png" alt="" />
                    </div>
                    <div className="shape4 wow slideInRight" data-wow-delay="100ms" data-wow-duration="3000ms">
                        <img className="rotate-me" src="assets/images/shape/thm-shape-12.png" alt="" />
                    </div>
                    <div className="container-fullwidth">
                        <div className="choose-style1-img-box" style={{ backgroundImage: 'url(assets/images/resources/choose-style1-img.jpg)' }} />
                        <div className="choose-style1-content-box">
                            <div className="sec-title">
                                <div className="sub-title">
                                    <p>Why Choose Us</p>
                                </div>
                                <h2>Why Choose BUDPLAN
                                    for Construction Planning
                                </h2>
                            </div>
                            <div className="inner-content">
                                <p>We provide reliable construction consultancy services focused on smart planning,
                                    regulatory compliance, and smooth project execution for residential and
                                    commercial developments.
                                </p>
                                <ul>
                                    <li>
                                        <div className="icon">
                                            <span className="flaticon-checked" />
                                        </div>
                                        <div className="text">
                                            <h4>Experienced Professionals</h4>
                                            <p>Our architects and consultants bring strong industry expertise to handle
                                                planning, approvals, and execution support efficiently.
                                            </p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <span className="flaticon-checked" />
                                        </div>
                                        <div className="text">
                                            <h4>End-to-End Consultancy
                                            </h4>
                                            <p>We manage everything from architectural design to approvals, layouts,
                                                TDR services, and government schemes under one roof.
                                            </p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <span className="flaticon-checked" />
                                        </div>
                                        <div className="text">
                                            <h4>Trusted & Compliant Process</h4>
                                            <p>Our structured approach ensures transparent documentation, timely approvals,
                                                and full compliance with regulations.</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
                {/*End Choose  Style1 Area*/}







            </div>

        </>
    )
}

export default Services;